import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import Box from '../Box';
import Checkbox from '../Checkbox';
import Highlighter from '../Highlighter';
import HighlightContext from '../InputWithOptions/HighlightContext';
import Text from '../Text';
import { dataHooks, SIZES } from './ListItemSelect.constants';
import { classes, st } from './ListItemSelect.st.css.js';
const ListItemSelect = ({ checkbox = false, selected = false, highlighted, ellipsis = false, size = SIZES.medium, dataHook = 'list-item-select', className, disabled, onClick, prefix, suffix, title, subtitle, tooltipProps, }) => {
    const { highlight, match } = useContext(HighlightContext);
    const WrapperComponent = checkbox ? Checkbox : React.Fragment;
    const HighlightWrapper = highlight ? Highlighter : React.Fragment;
    const wrapperComponentProps = checkbox
        ? {
            dataHook: dataHooks.CHECKBOX,
            className: classes.fullWidthContent,
            size,
            checked: selected,
            disabled,
        }
        : {};
    const highlightWrapperProps = highlight ? { match } : {};
    const textProps = {
        tagName: 'div',
        size,
        ellipsis,
        tooltipProps,
        skin: disabled ? 'disabled' : 'standard',
        weight: 'thin',
        light: selected && !checkbox,
    };
    const secondaryTextProps = {
        ...textProps,
        light: !disabled,
        secondary: !selected || checkbox,
    };
    return (React.createElement("div", { className: st(classes.root, {
            checkbox,
            selected,
            highlighted,
            disabled,
            size,
            hoverHighlightDisabled: highlighted === false,
        }, className), "data-hook": dataHook, "data-selected": selected, onClick: disabled ? undefined : onClick },
        React.createElement(WrapperComponent, { ...wrapperComponentProps },
            React.createElement(Box, { width: '100%', verticalAlign: 'middle', className: classes.textsWrapper },
                prefix && (React.createElement(Text, { className: st(classes.prefix, {
                        subtitle: Boolean(subtitle),
                    }), dataHook: dataHooks.PREFIX, ...textProps, ellipsis: false }, prefix)),
                React.createElement("div", { className: st(classes.titleWrapper, {
                        subtitle: Boolean(subtitle),
                    }) },
                    React.createElement(HighlightWrapper, { ...highlightWrapperProps },
                        React.createElement(Text, { className: classes.title, dataHook: dataHooks.TITLE, ...textProps }, title)),
                    subtitle && (React.createElement(Text, { className: classes.subtitle, dataHook: dataHooks.SUBTITLE, secondary: true, ...secondaryTextProps, size: SIZES.small }, subtitle))),
                suffix && (React.createElement(Text, { dataHook: dataHooks.SUFFIX, className: classes.suffix, ...secondaryTextProps }, suffix))))));
};
ListItemSelect.displayName = 'ListItemSelect';
ListItemSelect.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    checkbox: PropTypes.bool,
    prefix: PropTypes.any,
    title: PropTypes.any,
    subtitle: PropTypes.any,
    suffix: PropTypes.any,
    selected: PropTypes.bool,
    highlighted: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltipProps: PropTypes.any,
    onClick: PropTypes.func,
    size: PropTypes.any,
    ellipsis: PropTypes.bool,
};
export default ListItemSelect;
export const listItemSelectBuilder = ({ id, className, checkbox, prefix, title, label, subtitle, suffix, disabled, size, ellipsis, dataHook, tooltipProps, }) => ({
    id,
    disabled,
    overrideOptionStyle: true,
    label,
    value: ({ selected, hovered, ...rest }) => (React.createElement(ListItemSelect, { dataHook: dataHook, className: className, checkbox: checkbox, prefix: prefix, title: title, subtitle: subtitle, suffix: suffix, size: size, ellipsis: ellipsis, selected: selected, highlighted: hovered, tooltipProps: tooltipProps, ...rest })),
});
//# sourceMappingURL=ListItemSelect.js.map